import React from "react";
import Navbar from "../../components/navbar/Navbar";
import "../all css/counsellingreadmore.css";
import Footer from "../../components/footer/footer";
const wave_img = require("../../assets/wave_counellling_read_more.svg");
const vector_img = require("../../assets/counselling_hero_section_img.svg");

function CounsellingReadMoreSection(props) {
  return (
    <>
      <div className="nav_container">
        <Navbar fromPage="cousellingreadmoresection" />
      </div>
      <section className="main_container_couselling_read_more_section">
        <div className="main_heading_contianer">
          <div className="top_couselling_container">
            <div className="flx_container_text_extra_text_contianer">
              <p className="top_couselling_text">COUNSELLING</p>
              <p className="top_couselling_extra_text">
                Virtual counseling sessions for study abroad: At, DWEC, we
                assist you in your study abroad journey by reaching out to you
                in person. Stay in your comfort zone and let us guide you with
                brilliant career opportunities ahead.
              </p>
            </div>
            <div className="top_couselling_imgSec_container">
              <div className="top_couselling_img_container">
                <img src={vector_img.default} alt="img" />
              </div>
            </div>
          </div>
        </div>
        <div className="wave_img_contianer">
          <img src={wave_img.default} alt="img" />
        </div>

        <div className="main_border_container">
          <p className="title_text_counselling">
            Counseling is the first step of your study abroad dream. Getting
            counseled is what makes you to embark on a new journey.
          </p>
          <div className="margin_container">
            <p className="highlight_text_extra_text">
              <span className="highlight_text_counselling">
                Are you perplexed regarding your study abroad dream?
              </span>{" "}
              Then worry not, we, here at Dynamic World Education Community
              offer personalized counseling services. And the best part about it
              is we take no charge for consulting us. Counseling is an important
              part of the study abroad journey. Students need to know the best
              course and institution for them. We counsel students by knowing
              about their interests and aptitude and suggesting them the best
              course and university that suits them.
            </p>
          </div>

          <div className="margin_container">
            <p className="highlight_text_extra_text">
              <span className="highlight_text_counselling">
                Our organization sticks to its name and provides you with the
                best and affordable counseling services. At DWEC, we assist you
                with:
              </span>
            </p>
          </div>

          <ul className="highlight_text_counselling">
            <li>You will get to know about possible career opportunities</li>

            <li>
              You will be provided with the future job prospectus information of
              the course chosen.
            </li>

            <li>
              You will understand the international scenario of the chosen
              field.
            </li>

            <li>
              You will get free profile evaluation done for possible
              scholarships.
            </li>
          </ul>

          <div className="margin_container">
            <p className="highlight_text_extra_text">
              We have excellent counselors who have great expertise in the
              field. Our counselors work on each and every student and provide
              them the most suitable opportunities in the international arena.
              They have tie ups with agents who are directly in touch with the
              foreign universities and colleges.
            </p>
          </div>

          <p className="highlight_text_counselling">
            Roles and responsibilities that we fulfill
          </p>

          <ul className="highlight_text_counselling">
            <li>
              We maintain the database of every student and the status of their
              Visa process.
            </li>

            <li>
              Our counselors support a student's academic needs along with their
              social and emotional needs.
            </li>

            <li>
              We, here at DWEC take care of the complete visa process. We
              collect visa applications from the respective embassies.
            </li>

            <li>
              From getting the form filled to verification of documents, we
              guide students during the entire process.
            </li>

            <li>
              We listen to students' queries and give them suitable guidance.
            </li>
          </ul>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default CounsellingReadMoreSection;
